var React = require('react');

function InputFile (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#502314","d":"M14.722 1.14c-1.52-1.52-3.99-1.52-5.51 0L2.468 7.882c-.213.213-.213.558 0 .771.213.213.558.213.771 0L9.983 1.91c1.094-1.093 2.874-1.093 3.968 0 .53.53.822 1.235.822 1.984 0 .75-.292 1.454-.822 1.984l-8.476 8.476c-.742.742-1.95.742-2.692 0-.741-.743-.742-1.95 0-2.692l8.455-8.44c.39-.39 1.026-.39 1.417 0 .39.39.39 1.026 0 1.416L5.93 11.346c-.213.213-.213.558 0 .771.213.213.558.213.771 0l6.724-6.708c.815-.816.815-2.142 0-2.958-.816-.816-2.143-.815-2.958 0l-8.456 8.44c-1.167 1.167-1.167 3.066 0 4.233.584.584 1.35.876 2.118.876.766 0 1.533-.292 2.116-.876l8.476-8.475c.736-.736 1.141-1.714 1.141-2.755 0-1.04-.405-2.019-1.141-2.755z"}));
}

InputFile.defaultProps = {"width":"17","height":"16","fill":"none","viewBox":"0 0 17 16"};

module.exports = InputFile;

InputFile.default = InputFile;
